import React from 'react';
import './contact.css';
import { useState } from "react";
import { db, realtimeDB } from '../../Components/Firebase/firebase';

const ContactUs = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name || !email || !message) {
            alert("Please fill in all fields");
            return;
        }
        db.collection('contacts').add({
            name: name,
            email: email,
            message: message,
        })
            .then(() => {
                alert("Message Sent");
            })
            .catch((error) => {
                alert(error.message);
            });

        const usersRef = realtimeDB.ref('users');
        usersRef.push({
            name: name,
            email: email,
            message: message,
        }, (error) => {
            if (error) {
                console.error('Error adding document to Realtime Database: ', error);
            } else {
                console.log('Document added successfully to Realtime Database!');
            }
        });
        setName('');
        setEmail('');
        setMessage('');
    };
    return (
        <form className='form'>
            <div className="contact-container">
                <div className="color5"></div>
                <div className="color4"></div>
                <h1>Contact Us</h1>
                <div className="container3">
                    <div className="content2">
                        <div className="left-side">
                            {/* <div className="address details">
                                <i className="fas fa-map-marker-alt"></i>
                                <div className="topic">Address</div>
                                <div className="text-one"> SOHST, University of Petroleum and Energy Studies, Bidholi, Dehradun</div>

                            </div> */}
                            <div className="phone details">
                                <i className="fas fa-phone-alt"></i>
                                <div className="topic">Phone</div>
                                <div className="text-one">Bhanu Pratap Singh</div>
                                <div className="text-one">+91 9368344502</div>
                                <div className="text-two">Sanskar Kumar</div>
                                <div className="text-two">+91 8809452044</div>
                            </div>
                            <div className="email details">
                                <i className="fas fa-envelope"></i>
                                <div className="topic">Email</div>
                                <div className="text-one">o3.sohst@stu.upes.ac.in</div>
                            </div>
                        </div>
                        <div className="right-side">
                            <div className="topic-text">Send us a message</div>
                            <p>Need assistance? Reach out to us anytime, and our team will get back to you within 24 hours.</p>
                            <form action="#">
                                <div className="input-box">
                                    <input type="text" placeholder="Enter your name" value={name} onChange={(e) => setName(e.target.value)} required />
                                </div>
                                <div className="input-box">
                                    <input type="text" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                </div>
                                <div className="input-box message-box">
                                    <textarea placeholder="Enter your message" value={message} onChange={(e) => setMessage(e.target.value)} required></textarea>
                                </div>
                                <div className="button" onClick={handleSubmit}>
                                    <input type="button" value="Send Now" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default ContactUs;
